import { elementContains, getElementLayout } from './element';
export function isElementNested(element) {
    return !!element.parent;
}
export function isElementDescendantOfType(element, type) {
    var parent = element.positionParent;
    while (parent) {
        if (parent.className === type) {
            return true;
        }
        parent = parent.positionParent;
    }
    return false;
}
export function getAncestorOfElementThatIsChildOfCurrentSelection(currentSelection, element) {
    if (currentSelection) {
        var ancestor = element;
        while (ancestor) {
            if (ancestor.parent === currentSelection) {
                return ancestor;
            }
            ancestor = ancestor.parent;
        }
    }
    return undefined;
}
export function getAncestorOfElementThatIsSiblingOfCurrentSelection(currentSelection, element) {
    if (currentSelection) {
        var ancestor = element;
        while (ancestor) {
            if (ancestor.parent === currentSelection.parent) {
                return ancestor;
            }
            ancestor = ancestor.parent;
        }
    }
    return undefined;
}
export function getAncestorOfElementThatIsParentOfCurrentSelection(currentSelection, element) {
    if (currentSelection) {
        var ancestor = element;
        while (ancestor) {
            if (ancestor === currentSelection.parent) {
                return ancestor;
            }
            ancestor = ancestor.parent;
        }
    }
    return undefined;
}
export function isElementInSameTopLevelGroupAsCurrentSelection(currentSelection, element) {
    if (!currentSelection) {
        return false;
    }
    return getTopLevelGroup(element) === getTopLevelGroup(currentSelection);
}
export function isElementInSameTopLevelGroupAsCurrentSelectionAndNoDeeper(currentSelection, element) {
    if (!currentSelection) {
        return false;
    }
    var isInSameGroup = isElementInSameTopLevelGroupAsCurrentSelection(currentSelection, element);
    if (!isInSameGroup) {
        return false;
    }
    return getDepth(element) <= getDepth(currentSelection);
}
export function getTopLevelGroup(element, currentSelection) {
    var _a;
    var parent = element;
    while (parent.parent) {
        if (parent.parent === currentSelection) {
            return parent;
        }
        (_a = parent, parent = _a.parent);
    }
    return parent;
}
export function getDepth(element) {
    var _a;
    var parent = element;
    var depth = 0;
    while (parent.parent) {
        depth += 1;
        (_a = parent, parent = _a.parent);
    }
    return depth;
}
function getParents(element) {
    var currentElement = element;
    var parents = [];
    while (currentElement.parent) {
        parents.unshift(currentElement);
        currentElement = currentElement.parent;
    }
    return parents;
}
export function getElementLayoutForPercentage(artboard, element1, element2) {
    if (!artboard || !element1 || !element2) {
        // Might occur when running tests
        return {};
    }
    if (elementContains(element2, element1)) {
        return getElementLayout(element1);
    }
    if (elementContains(element1, element2)) {
        return getElementLayout(element2);
    }
    return getLowestCommonAncestorLayout(artboard, element1, element2);
}
// Return the layout of the lowest common ancestor (LCA) of two elements.
// The LCA is the lowest (i.e. deepest) element that has both element1 and
// element2 as descendants
function getLowestCommonAncestorLayout(artboard, element1, element2) {
    var parents1 = getParents(artboard, element1);
    var parents2 = getParents(artboard, element2);
    for (var i = 0; i < parents1.length; i += 1) {
        if (parents1[i].id !== parents2[i].id) {
            var ancestor = parents1[i - 1];
            return ancestor ? getElementLayout(ancestor) : artboard;
        }
    }
    return artboard;
}
